import { message } from "antd";
import * as XLSX from "xlsx";

const ExportToExcel = (tableData, title) => {
  if (tableData.length === 0) {
    message.error("No data found to export!");
    return;
  }
  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.json_to_sheet(tableData);
  XLSX.utils.book_append_sheet(wb, ws, title);
  XLSX.writeFile(wb, `${title}.xlsx`);
};

export default ExportToExcel;
